import React, { Fragment, useEffect, useState } from 'react'
import { useTheme, makeStyles } from '@material-ui/core/styles'
import { useDispatch, useSelector } from 'react-redux'
import Box from '@material-ui/core/Box'
import { Typography } from '@material-ui/core'
import { useHistory } from 'react-router-dom'
import { ReactComponent as UnkownImage } from '../../assets/cfdUnknownImage.svg'
import { getCardError } from '../Selectors'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    justifyContent: 'center',
    height: '100%',
    alignItems: 'center'
  },
  subRoot: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column',
  }
}))

export const VNStatusScreen = (props) => {

  const classes = useStyles()

  const dispatch = useDispatch()

  // const { t } = useTranslation()

  const theme = useTheme()
  const history = useHistory()

  // SELECTORS
  const cardError = useSelector(state => getCardError(state))

  // LOCAL STATE

  // USE EFFECTS

  const displaySubTitle = () => {

    const text = props.subtitle || cardError.get('subTitle')

    if (text) {
      return (<Box pt={1}>
        <Typography style-={theme.custom.subtitle3}>
          {text.split("\n").map((i, key) => {
            return <div style={{textAlign: 'center'}} key={key}>{i}</div>
          })}
        </Typography>
      </Box>
      )
    }
  }

  const displayTitle = () => {

    const text = props.title || cardError.get('title')

    if (text) {
      return (
        <Typography variant='h3'>
          {text.split("\n").map((i, key) => {
            return <div style={{textAlign: 'center'}} key={key}>{i}</div>
          })}
        </Typography>
      )
    }
  }

  return (
    <Box className={classes.root}>
      <Box className={classes.subRoot}>
        <Box>
          {props.image}
        </Box>
        {displayTitle()}
        {displaySubTitle()}
      </Box>
    </Box>
  )
}
